import React, { useEffect } from "react";
import { useAppDispatch } from "app/hooks";
import CenterContainer from "features/containers/CenterContainer";
import { Link } from "react-router-dom";
import { resetState } from "./resetPasswordSlice";
import { Card } from "@mui/material";

const ResetComplete: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetState());
    };
  });

  return (
    <CenterContainer>
      <Card elevation={8} sx={{ p: 4, borderRadius: "1rem" }} className="form-signin">
        <h1>Klart!</h1>
        <p>Du kan nu logga in med ditt nya lösenord!</p>
        <div className="mb-5 mt-3">
          <Link to="/login">Till logga in</Link>
        </div>
      </Card>
    </CenterContainer>
  );
};

export default ResetComplete;
